import script from "./AssistentsConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentsConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./AssistentsConfiguration.vue?vue&type=style&index=0&id=139988f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139988f0"]])

export default __exports__